define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
	"csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	const collectionAdminRoles = ['Collection Administrator'];

	const materialUsageAdminRoles = ['Material Usage Administrator'];

	const productSpecAdminRoles = ['Product Specification Administrator'];
	const productSpecEditorRoles = productSpecAdminRoles.concat(['Product Specification Editor']);
	const productSpecLibAdminRoles = ['Product Specification Library Administrator'];

	const artworkCreatorRoles  = ['TDS - Artwork Administrator','TDS - Artwork Creator'];
	const bomAdminRoles = ['TDS - BOM Administrator'];
	const bomCreatorRoles = ['TDS - BOM Creator'];
	const bomEditorRoles = bomAdminRoles.concat(['TDS - BOM Editor']);
	const imageCreatorRoles = ['TDS - Image Creator','TDS - Image Administrator'];
	const securityGroupAdminRoles = ['Security Group Administrator'];
	const propertiesCreatorRoles = ['TDS - Properties Creator','TDS - Properties Administrator'];
	const routingCreatorRoles = ['TDS - Routing Creator','TDS - Routing Administrator'];
	const sizeChartAdminRoles = ['TDS - Size Chart Administrator'];
	const sizeChartCreatorRoles = ['TDS - Size Chart Creator'];
	const sizeChartEditorRoles = sizeChartAdminRoles.concat(['TDS - Size Chart Editor']);
	const sizeLabelCreatorRoles = ['TDS - Size Label Creator','TDS - Size Label Administrator'];
	const tdsCareCompCreatorRoles = ['TDS - Care and Composition Administrator', 'TDS - Care and Composition Creator'];
	const tdsColorwayReviewCreatorRoles = ['TDS - Colorway Review Creator','TDS - Colorway Review Administrator'];
	const tdsSKUReviewCreatorRoles = ['TDS - SKU Review Creator','TDS - SKU Review Administrator'];
	const tdsSpecCreatorRoles = ['TDS - Spec Creator','TDS - Spec Administrator'];
	const shapeAdminRoles = ["Shape Administrator"];
	const styleReviewAdminRoles = ['TDS - Style Review Administrator'];
	const styleReviewCreatorRoles = ['TDS - Style Review Creator'];
	const sustainabilityAdminRoles = ['Sustainability Administrator'];
	const tdsSustainabilityProfileAdminRoles = sustainabilityAdminRoles.concat(['TDS - Sustainability Profile Administrator']);
	const tdsSustainabilityProfileCreatorRoles = tdsSustainabilityProfileAdminRoles.concat(['TDS - Sustainability Profile Creator']);

	csiAccess.addViewRoles({
		"Colorway":{
			"Reviews":{
				"Copy":access(full(productSpecAdminRoles), full(tdsColorwayReviewCreatorRoles)),
				"NewFrom":access(full(productSpecAdminRoles), full(tdsColorwayReviewCreatorRoles)),
				"NewReviewColorway":access(full(productSpecAdminRoles), full(tdsColorwayReviewCreatorRoles))
			}
		},
		"Collection":{
			"DataSheets":{
				"Copy":access(full(collectionAdminRoles)),
				"NewFrom":access(full(collectionAdminRoles)),
				"NewReviewCollection":access(full(collectionAdminRoles))
			}
		},
		"Shape":{
			"SizeCharts":{
				"Copy":access(full(productSpecAdminRoles), full(sizeChartAdminRoles), full(sizeChartCreatorRoles)),
				"MassUpdateStylesSizeChart":access(full(productSpecEditorRoles), full(sizeChartEditorRoles)),
				"NewSizeChart":access(full(productSpecAdminRoles), full(sizeChartAdminRoles), full(sizeChartCreatorRoles)),
				"NewFromShapeSizeChart":access(full(productSpecAdminRoles), full(sizeChartAdminRoles), full(sizeChartCreatorRoles)),
				"NewFromStyleSizeChart":access(full(productSpecAdminRoles), full(sizeChartAdminRoles), full(sizeChartCreatorRoles)),
				"NewFromTemplate":access(full(productSpecAdminRoles), full(sizeChartAdminRoles), full(sizeChartCreatorRoles))
			}
		},
		"SKU":{
			"Reviews":{
				"Copy":access(full(tdsSKUReviewCreatorRoles)),
				"NewFrom":access(full(tdsSKUReviewCreatorRoles)),
				"NewReviewColorway":access(full(tdsSKUReviewCreatorRoles))
			}
		},
		"StructureItem":{
			"MaterialSchedule":{
				"MaterialSchedule":access(full(productSpecAdminRoles))
			}
		},
		"Style":{
			"Artworks":{
				"Copy":access(full(productSpecAdminRoles), full(artworkCreatorRoles)),
				"NewArtwork":access(full(productSpecAdminRoles), full(artworkCreatorRoles)),
				"NewFromArtwork":access(full(productSpecAdminRoles), full(artworkCreatorRoles))
			},
			"BOMs":{
				"CarryOverFromStyleBOM":access(full(productSpecAdminRoles), full(bomAdminRoles), full(bomCreatorRoles)),
				"Copy":access(full(productSpecAdminRoles), full(bomAdminRoles), full(bomCreatorRoles)),
				"CreateSharedDataSheetsforAgents":access(full(productSpecAdminRoles), full(bomAdminRoles), full(bomCreatorRoles)),
				"MassUpdateSharedDataSheets":access(full(productSpecAdminRoles), full(bomEditorRoles), full(bomCreatorRoles)),
				"NewApparelBOM":access(full(productSpecAdminRoles), full(bomAdminRoles), full(bomCreatorRoles)),
				"NewFromApparelBOM":access(full(productSpecAdminRoles), full(bomAdminRoles), full(bomCreatorRoles)),
				"NewFromBOMTemplate":access(full(productSpecAdminRoles), full(bomAdminRoles), full(bomCreatorRoles)),
				"NewFromTheme":access(full(productSpecAdminRoles), full(bomAdminRoles), full(bomCreatorRoles)),
				"PullFromSourceBOM":access(full(productSpecAdminRoles), full(bomAdminRoles), full(bomCreatorRoles)),
				"UnlinkStyleBOMFromThemeBOM":access(full(productSpecAdminRoles), full(bomAdminRoles), full(bomCreatorRoles)),
			},
			"CareAndComposition": {
				"Copy":access(full(productSpecAdminRoles), full(tdsCareCompCreatorRoles)),
				"NewCareAndComposition":access(full(productSpecAdminRoles), full(tdsCareCompCreatorRoles)),
				"NewFromCareAndComposition":access(full(productSpecAdminRoles), full(tdsCareCompCreatorRoles))
			},
			"SustainabilityProfiles": {
				"NewSustainabilityProfile":access(full(tdsSustainabilityProfileCreatorRoles)),
				"Copy":access(full(tdsSustainabilityProfileCreatorRoles)),
				"Delete":access(full(tdsSustainabilityProfileAdminRoles)),
			},
			"ImageDataSheets":{
				"Copy":access(full(productSpecAdminRoles), full(imageCreatorRoles)),
				"NewImageDataSheet":access(full(productSpecAdminRoles), full(imageCreatorRoles)),
				"NewFromImageDataSheet":access(full(productSpecAdminRoles), full(imageCreatorRoles))
			},
			"PropertiesDataSheets":{
				"Copy":access(full(productSpecAdminRoles), full(propertiesCreatorRoles)),
				"NewPropertiesDataSheet":access(full(productSpecAdminRoles), full(propertiesCreatorRoles)),
				"NewFromPropertiesDataSheet":access(full(productSpecAdminRoles), full(propertiesCreatorRoles))
			},
			"Routing":{
				"Copy":access(full(productSpecAdminRoles), full(routingCreatorRoles)),
				"NewRouting":access(full(productSpecAdminRoles), full(routingCreatorRoles)),
				"NewFromRoutings":access(full(productSpecAdminRoles), full(routingCreatorRoles)),
				"NewFromRoutingTemplates":access(full(productSpecAdminRoles), full(routingCreatorRoles))
			},
			"SizeCharts":{
				"AddReferenceSizeChart":access(full(productSpecEditorRoles), full(sizeChartEditorRoles)),
				"Copy":access(full(productSpecAdminRoles), full(sizeChartAdminRoles), full(sizeChartCreatorRoles)),
				"NewSizeChart":access(full(productSpecAdminRoles), full(sizeChartAdminRoles), full(sizeChartCreatorRoles)),
				"NewFromShape":access(full(productSpecAdminRoles), full(sizeChartAdminRoles), full(sizeChartCreatorRoles)),
				"NewFromSizeChart":access(full(productSpecAdminRoles), full(sizeChartAdminRoles), full(sizeChartCreatorRoles)),
				"NewFromTemplate":access(full(productSpecAdminRoles), full(sizeChartAdminRoles), full(sizeChartCreatorRoles)),
				"PromoteToShape":access(full(shapeAdminRoles)),
				"PromoteSCFromStyleToShapeSC":access(full(productSpecAdminRoles), full(sizeChartAdminRoles), full(sizeChartCreatorRoles)),
			},
			"SizeLabel":{
				"Copy":access(full(productSpecAdminRoles), full(sizeLabelCreatorRoles)),
				"NewDataSheetSizeLabel":access(full(productSpecAdminRoles), full(sizeLabelCreatorRoles)),
				"NewFromDataSheetSizeLabel":access(full(productSpecAdminRoles), full(sizeLabelCreatorRoles))
			},
			"SpecificationDataSheets":{
				"Copy":access(full(productSpecAdminRoles), full(tdsSpecCreatorRoles)),
				"NewSpecificationDataSheet":access(full(productSpecAdminRoles), full(tdsSpecCreatorRoles)),
				"NewFromSpecificationDataSheet":access(full(productSpecAdminRoles), full(tdsSpecCreatorRoles)),
				"NewSpecificationDataSheetFromTemplate":access(full(productSpecAdminRoles), full(tdsSpecCreatorRoles))
			},
			"StyleReviews":{
				"RollIteration":access(full(productSpecAdminRoles), full(styleReviewAdminRoles), full(styleReviewCreatorRoles)),
				"NewReviewStyle":access(full(productSpecAdminRoles), full(styleReviewAdminRoles), full(styleReviewCreatorRoles)),
				"NewFromReviewStyle":access(full(productSpecAdminRoles), full(styleReviewAdminRoles), full(styleReviewCreatorRoles))
			}
		},
		"Material":{
			"WhereUsedApparelBOM":{
				"ClearColorLocks":access(full(materialUsageAdminRoles)),
				"MassAddMaterial":access(full(materialUsageAdminRoles)),
				"MassCreateDependentPartMaterial":access(full(materialUsageAdminRoles)),
				"MassRefreshUnitCost":access(full(materialUsageAdminRoles)),
				"MassReplace":access(full(materialUsageAdminRoles)),
				"MassDeletePartMaterials":access(full(materialUsageAdminRoles))
			},
			"WhereUsedThemeBOM":{
				"MassReplace":access(full(materialUsageAdminRoles)),
				"MassCreateDependentPartMaterial":access(full(materialUsageAdminRoles)),
				"MassAddMaterial":access(full(materialUsageAdminRoles))
			}
		},
		"SizeChartAdmin":{
			"Dimensions": {
				"Copy":access(full(productSpecLibAdminRoles)),
				"NewApparelDimension":access(full(productSpecLibAdminRoles))
			},
			"Increments":{
				"Copy":access(full(productSpecLibAdminRoles)),
				"NewIncrement":access(full(productSpecLibAdminRoles))
			},
			"ProductGroups":{
				"Copy":access(full(productSpecLibAdminRoles)),
				"NewProductGroup":access(full(productSpecLibAdminRoles))
			},
			"SizeChartTemplates": {
				"Copy":access(full(productSpecAdminRoles), full(sizeChartAdminRoles)),
				"NewSizeChart":access(full(productSpecAdminRoles), full(sizeChartAdminRoles))
			},
			"SizeLabels":{
				"Copy":access(full(productSpecLibAdminRoles)),
				"NewSizeLabel":access(full(productSpecLibAdminRoles))
			},
			"StyleBOMTemplates":{
				"Copy":access(full(productSpecAdminRoles), full(bomAdminRoles)),
				"Delete":access(full(productSpecAdminRoles), full(bomAdminRoles)),
				"NewApparelBOM":access(full(productSpecAdminRoles), full(bomAdminRoles))
			}
		},
		"SizeChartRevision":{
			"Dimensions": {
				"MassUpdateStylesSizeChart":access(full(productSpecEditorRoles), full(sizeChartEditorRoles)),
			}
		}
	});
});